<form [formGroup]="group" class="row justify-content-center">
  <div class="col-12 col-md-10 py-4">
    <div class="row">
      <h5 class="text-center mt-3 mb-5">These fields cannot be edited</h5>

      <div class="col-md-6 mb-3">
        <div class="form-floating">
          <input
            id="firstName"
            formControlName="firstName"
            [ngClass]="validate('firstName')"
            type="text"
            class="form-control" />
          <label for="firstName">
            <span class="text-danger small">*</span>
            Resident First Name
          </label>
        </div>
      </div>
      <div class="col-md-6 mb-3">
        <div class="form-floating">
          <input
            id="lastName"
            formControlName="lastName"
            [ngClass]="validate('lastName')"
            type="text"
            class="form-control" />
          <label for="lastName">
            <span class="text-danger small">*</span>
            Resident Last Name
          </label>
        </div>
      </div>
    </div>
  </div>
</form>
